export default "__VITE_ASSET__CvL9Tfl9__"